import React, { useCallback } from 'react'
import { FloatEditorFunc } from '@/components/report-tables/editors/fFloatEditor'
import { areEditorPropsEqual } from '@/components/report-tables/editors/fInputEditor'

const precision = 4

const FloatPercentageEditorFunc = React.memo(function FloatPercentageEditorFunc (props) {
  const getPersistenceValue = useCallback((value) => {
    const float = parseFloat(value)
    return `${!isNaN(float) ? (float / 100).toFixed(precision + 2) : ''}`
  }, [])

  const getValue = useCallback((rawValue, char) => {
    const float = parseFloat(rawValue)
    const value = `${!isNaN(float) ? parseFloat((float * 100).toFixed(precision)) : ''}`
    return { value: value + char, start: value.length + 1, end: value.length + 1, persistTransform: getPersistenceValue }
  }, [getPersistenceValue])

  return <FloatEditorFunc getValue={getValue} {...props} />
}, areEditorPropsEqual)

export { FloatPercentageEditorFunc }



// WEBPACK FOOTER //
// ./src/components/report-tables/editors/fFloatPercentageEditor.js